import { createClient, Provider } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_KEY || '';
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export const getSession = async () => {
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error || !session) {
        return null;
    } else {
        return session;
    }
};

type Piece = {
    name: string;
    position: string;
};

export const create8x8Layout = async (pieces: Piece[]): Promise<any | null> => {
    try {
        // Sanity checks
        if (!Array.isArray(pieces) || pieces.length === 0) {
            throw new Error("Pieces must be a non-empty array.");
        }

        // Validate each piece object
        for (const piece of pieces) {
            if (
                !piece.name ||
                !piece.position ||
                typeof piece.name !== "string" ||
                typeof piece.position !== "string"
            ) {
                throw new Error(
                    "Each piece must have 'name', and 'position' as strings."
                );
            }
        }

        // Get the current user's session
        const session = await getSession();
        if (!session) {
            throw new Error("User session not found. Please log in.");
        }

        const userId = session.user.id; // Extract user_id from the session

        // Insert into Supabase with user_id
        const { data, error } = await supabase
            .from("initial-state-8x8")
            .insert([{ pieces, user_id: userId }]);

        if (error) {
            console.error("create8x8Layout error:", error);
            return null;
        }

        return data;
    } catch (err) {
        console.error("create8x8Layout:", err);
        return null;
    }
};

export const handleGoogleSignIn = async () => {

    const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME || '';

    try {
        const { data, error } = await supabase.auth.signInWithOAuth({
            provider: "google",
            options: {
                redirectTo: DOMAIN_NAME + "/home",
            },
        });

        if (error) {
            console.error("Error signing in:", error.message);
            return null;
        }
    } catch (err) {
        console.error("Unexpected error:", err);
        return null
    }
};

export const handleProviderSignIn = async (provider: Provider) => {
    const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME || '';

    try {
        const { data, error } = await supabase.auth.signInWithOAuth({
            provider,
            options: {
                redirectTo: `${DOMAIN_NAME}/home`,
            },
        });

        if (error) {
            console.error(`Error signing in with ${provider}:`, error.message);
            return null;
        }
    } catch (err) {
        console.error(`Unexpected error with ${provider}:`, err);
        return null;
    }
};
